import React from 'react';
import styled from 'styled-components';
import * as icons from '@boxine/tonies-ui/icons';
import { media, theme } from '../themes/theme';
import Icon from '../Icon';
import { ImageV2 } from '../ImageV2';
import { CardOuter, CardInner, CardAspectRatioInner } from './shared';
import { Skeleton } from './PlaceholderCard';
const StyledBackgroundLayer = styled.div `
  background-color: ${props => props.status === 'available' || props.status === 'purchasable'
    ? 'transparent'
    : props.status === 'currentlyAssigned'
        ? props.theme.colors['green-40']
        : props.status === 'defaultAvailable'
            ? props.theme.colors['pink-20']
            : 'transparent'};
  border-radius: 1rem;
`;
const StyledCardInner = styled.span `
  ${CardInner}

  background: ${props => props.theme.colors.white};
  position: relative;
  border-bottom-right-radius: ${props => (props.hasIcon ? '4.25rem' : '1rem')};

  ${media.tablet `
    border-bottom-right-radius: ${props => (props.hasIcon ? '5rem' : '1rem')};
    `}
`;
const CardAspectSquare = styled.span `
  height: 0;
  padding-top: 100%;
  width: 100%;
  display: block;
`;
const StyledIcon = styled(Icon) `
  position: absolute;
  right: 0.25rem;
  bottom: 0.275rem;
  z-index: 2;
  height: 1rem;
  width: 1rem;

  ${media.tablet `
    height: 1.25rem;
    width: 1.25rem;
  `}
`;
export function CoverCard({ src, alt, className = undefined, status = undefined, placeholder = undefined, }) {
    return (React.createElement(CardOuter, { "data-testid": "cover-card", className: className },
        React.createElement(CardAspectSquare, null,
            React.createElement(CardAspectRatioInner, null,
                React.createElement(StyledBackgroundLayer, { hasIcon: status === 'currentlyAssigned' || status === 'defaultAvailable', status: status, "data-testid": "card-shadow" },
                    React.createElement(StyledCardInner, { hasIcon: status === 'currentlyAssigned' || status === 'defaultAvailable' },
                        React.createElement(ImageV2, { src: src, alt: alt, title: alt, ratio: [1, 1], crop: "fill", placeholder: placeholder, dataTestId: "cover-card" })),
                    status === 'currentlyAssigned' && (React.createElement(StyledIcon, { type: icons.checkmarkFill, fill: theme.colors['green-100'] })),
                    status === 'defaultAvailable' && (React.createElement(StyledIcon, { type: icons.filledArrowCircleCcw, fill: theme.colors.primary })))))));
}
const CoverCardSkeleton = styled.span `
  ${props => Skeleton(props.theme.colors.lightergrey, props.theme.colors.white)};
  width: 100%;
  height: 100%;
`;
export function CoverCardPlaceholder({ className = undefined, }) {
    return (React.createElement(CardOuter, { "data-testid": "cover-card-placeholder", className: className },
        React.createElement(CardAspectSquare, null,
            React.createElement(CardAspectRatioInner, null,
                React.createElement(StyledCardInner, null,
                    React.createElement(CoverCardSkeleton, null))))));
}
